import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFormatSize$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFormatSize extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ff9e811b47ebac4e3866636b3ced913180474e62', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '33c1a11a1a50f9dfc196c215cdc0aa324ef04e26', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e6303a8ac271afb212a7700772e8ed5b7fa944e1', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8 5v-.48A.5.5 0 0 1 8.5 4h11a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5h-4.75v12a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-12H8.5A.5.5 0 0 1 8 5m-2.75 6.51H2.5A.5.5 0 0 1 2 11v-.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.51H6.75v6a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-format-size", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-format-size"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-format-size":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFormatSize$1);
            }
            break;
    } });
}

const CosmosIconFormatSize = CosmosIconFormatSize$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFormatSize, defineCustomElement };
